import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=5ce21cd0&scoped=true&"
import script from "./ListItems.vue?vue&type=script&lang=js&"
export * from "./ListItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce21cd0",
  null
  
)

export default component.exports